import axios from 'axios';
import {apiUrl} from "../../constants/config";

export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getSessionById({}, id) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/session/' + id).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        getSessionDetailsById({}, id) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/session/' + id + '/details').then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        submitSession({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/session/', payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        updateSession({}, payload) {
            return new Promise((resolve, reject) => {
                axios.put(apiUrl + 'api/session/' + payload.id, payload.data).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        deleteSession({}, id) {
            return new Promise((resolve, reject) => {
                axios.delete(apiUrl + 'api/session/' + id).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        submitSurvey({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/session/' + payload.id + '/survey', payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        deleteSessionFile({}, payload) {
            return new Promise((resolve, reject) => {
                axios.delete(apiUrl + 'api/session/' + payload.id + '/material/' + payload.matId + '/' + payload.file).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        updateSessionFile({}, payload) {
            return new Promise((resolve, reject) => {
                axios.put(apiUrl + 'api/session/' + payload.session_id + '/material/' + payload.id + '/' + payload.file, payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        }
    }
};
